import config from '@/config'
import AppState from '@/states/app'
import { requests } from './BaseService'

export interface IWhatsapp {
  to: string
  template: {
    name: string
    language: string
    placeholders: {
      header: Array<string>
      body: Array<string>
      footer: Array<string>
      buttons: Array<Object>
    }
  }
}

export default class WhatsappService {
  whatsapp: IWhatsapp

  constructor(whatsapp) {
    this.whatsapp = whatsapp
  }

  async sendTestWhatsapp() {
    try {
      const meta = {
        companyId: AppState.companyId,
        locationId: AppState.locationId,
      }
      const data = {
        type: 'template',
        template: {
          name: this.whatsapp.template.name,
          lang: this.whatsapp.template.language,
        },
        placeholders: {
          header: this.whatsapp.template.placeholders.header || [],
          body: this.whatsapp.template.placeholders.body || [],
          footer: this.whatsapp.template.placeholders.footer || [],
          buttons: this.whatsapp.template.placeholders.buttons || [],
        },
        toNumbers: [this.whatsapp.to],
      }
      const payload = {
        meta,
        data
      }
      await requests().post(`${config.calendarApiUrl}/phone-system/whatsapp/message/send-notification`, payload)
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  async checkWhatsAppReadiness() {
    const url = `${config.restApiUrl}/phone-system/whatsapp/company/${AppState.companyId}/location/${AppState.locationId}/is-ready`
    const { data } = await requests().get(url)
    return data
  }
}

export const WhatsappTemplateService = {
  getTemplateStatusForLocation: async () => {
    const url = `${config.calendarApiUrl}/calendars/${AppState.companyId}/${AppState.locationId}/whatsapp/template-status`
    const { data } = await requests().get(url)
    return data
  },

  getDefaultTemplates: (locationId: string) => {
    const url = `phone-system/whatsapp/location/${locationId}/CALENDAR_NOTIFICATION/template-status`
    return requests().get(`${config.restApiUrl}/${url}`)
  },

  getUserTemplates: (locationId: string) => {
    const url = `phone-system/whatsapp/location/${locationId}/template`
    return requests().get(`${config.restApiUrl}/${url}`)
  },

  getTemplateById: (locationId: string, templateId: string) => {
    const url = `phone-system/whatsapp/location/${locationId}/CALENDAR_NOTIFICATION/template/${templateId}`
    return requests().get(`${config.restApiUrl}/${url}`)
  }
}
